import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle, renderSlot as _renderSlot, createElementVNode as _createElementVNode, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "swipe-list" };
const _hoisted_2 = ["data-item-id", "onMousedown", "onMousemove", "onMouseup", "onMouseleave", "onTouchstart", "onTouchmove", "onTouchend", "onTouchcancel"];
const _hoisted_3 = ["src", "onClick"];
const _hoisted_4 = ["onClick"];
import { ref, watch, onMounted, getCurrentInstance, nextTick } from 'vue';
// Global state to track currently open swipe
const clickThreshold = 10;
const clickTimeThreshold = 200;
export default /*@__PURE__*/ _defineComponent({
    __name: 'SwipeActionsContainer',
    props: {
        preview: { type: Boolean, default: true },
        items: {},
        swipeThreshold: { default: 80 },
        actionWidth: { default: 120 },
        backgroundColor: { default: 'var(--background-color)' },
        actions: { default: () => [
                {
                    icon: 'mdi-pencil',
                    color: 'grey',
                    type: 'edit',
                    backgroundColor: 'var(--background-color-alt)'
                },
                {
                    icon: 'mdi-delete',
                    color: 'grey',
                    type: 'delete',
                    backgroundColor: 'var(--background-color-alt)'
                }
            ] },
        mailStyleSwipe: { type: Boolean, default: false }
    },
    emits: ["action-click", "content-click", "swipe-start", "swipe-move", "swipe-end", "swipe-cancel"],
    setup(__props, { expose: __expose, emit: __emit }) {
        _useCssVars(_ctx => ({
            "7c905324": (props.backgroundColor)
        }));
        const globalSwipeState = {
            currentOpenId: null,
            setOpenId(id) {
                if (globalSwipeState.currentOpenId !== id) {
                    const oldId = globalSwipeState.currentOpenId;
                    globalSwipeState.currentOpenId = id;
                    return oldId;
                }
                return null;
            },
            clearOpenId() {
                globalSwipeState.currentOpenId = null;
            }
        };
        const props = __props;
        const emit = __emit;
        const instance = getCurrentInstance();
        const swipeStates = ref(new Map());
        let clickStartTime = null;
        let clickStartX = null;
        const pendingDeleteIds = ref([]);
        const leavingIds = ref([]);
        function getSwipeState(item) {
            return swipeStates.value.get(item.id);
        }
        function resetSwipeState(item) {
            const swipeState = getSwipeState(item);
            if (!swipeState)
                return;
            Object.assign(swipeState, {
                swiping: false,
                isSwiping: false,
                startX: 0,
                currentX: 0,
                initialOffset: 0,
                finalOffset: 0
            });
            nextTick(() => {
                const el = instance?.proxy?.$el;
                if (el) {
                    const content = el.querySelector(`[data-item-id="${item.id}"] .swipe-content`);
                    if (content) {
                        content.style.transition = 'transform 0.3s ease';
                        content.style.transform = 'translateX(0)';
                    }
                }
            });
        }
        function startSwipe(event, item) {
            const swipeState = getSwipeState(item);
            if (!swipeState)
                return;
            clickStartTime = Date.now();
            clickStartX = event.type === 'mousedown' ? event.clientX : event.touches[0].clientX;
            swipeState.startY = event.type === 'mousedown' ? event.clientY : event.touches[0].clientY;
            const previousOpenId = globalSwipeState.setOpenId(item.id);
            if (previousOpenId && previousOpenId !== item.id) {
                const previousItem = props.items.find(i => i.id === previousOpenId);
                if (previousItem) {
                    resetSwipeState(previousItem);
                }
            }
            const clientX = event.type === 'mousedown' ? event.clientX : event.touches[0].clientX;
            if (swipeState.finalOffset) {
                Object.assign(swipeState, {
                    startX: clientX,
                    currentX: clientX,
                    swiping: true,
                    initialOffset: swipeState.finalOffset,
                    isSwiping: false
                });
            }
            else {
                Object.assign(swipeState, {
                    startX: clientX,
                    currentX: clientX,
                    swiping: true,
                    initialOffset: 0,
                    finalOffset: 0,
                    isSwiping: false
                });
            }
            emit('swipe-start', { item, event });
        }
        function moveSwipe(event, item) {
            const swipeState = getSwipeState(item);
            if (!swipeState || !swipeState.swiping)
                return;
            const clientX = event.type === 'mousemove' ? event.clientX : event.touches[0].clientX;
            const clientY = event.type === 'mousemove' ? event.clientY : event.touches[0].clientY;
            const diffX = clientX - swipeState.startX;
            const diffY = clientY - (swipeState.startY || clientY);
            if (event.type === 'touchmove' && Math.abs(diffX) > Math.abs(diffY)) {
                event.preventDefault();
            }
            if (Math.abs(diffX) > clickThreshold) {
                swipeState.isSwiping = true;
            }
            let newOffset = (swipeState.initialOffset || 0) + diffX;
            if (newOffset > 0) {
                newOffset = 0;
            }
            if (!props.mailStyleSwipe && newOffset < -props.actionWidth) {
                newOffset = -props.actionWidth;
            }
            swipeState.currentX = swipeState.startX + (newOffset - (swipeState.initialOffset || 0));
            if (props.mailStyleSwipe) {
                let rowWidth = 1;
                const el = instance?.proxy?.$el;
                if (el && el.querySelector) {
                    const row = el.querySelector(`[data-item-id="${item.id}"]`);
                    if (row && row.offsetWidth) {
                        rowWidth = row.offsetWidth;
                    }
                }
                if (newOffset < -0.80 * rowWidth && !pendingDeleteIds.value.includes(item.id)) {
                    const deleteAction = props.actions.find(a => a.type === 'delete');
                    if (deleteAction) {
                        pendingDeleteIds.value.push(item.id);
                        if (swipeState) {
                            swipeState.finalOffset = -rowWidth;
                            swipeState.swiping = false;
                            swipeState.isSwiping = false;
                        }
                        setTimeout(() => {
                            emit('action-click', { item, action: deleteAction });
                        }, 300);
                        return;
                    }
                }
            }
            emit('swipe-move', { item, event, offset: getSwipeOffset(item) });
        }
        function endSwipe(event, item) {
            const swipeState = getSwipeState(item);
            if (!swipeState || !swipeState.swiping)
                return;
            const clientX = event.type === 'mouseup' ? event.clientX : event.changedTouches[0].clientX;
            const diff = clientX - swipeState.startX;
            const timeDiff = Date.now() - (clickStartTime || 0);
            const isClick = Math.abs(diff) <= clickThreshold && timeDiff <= clickTimeThreshold;
            if (isClick) {
                resetSwipeState(item);
                emit('content-click', { item });
                return;
            }
            const totalOffset = (swipeState.initialOffset || 0) + diff;
            let finalOffset = 0;
            if (props.mailStyleSwipe) {
                let rowWidth = 1;
                const el = instance?.proxy?.$el;
                if (el && el.querySelector) {
                    const row = el.querySelector(`[data-item-id="${item.id}"]`);
                    if (row && row.offsetWidth) {
                        rowWidth = row.offsetWidth;
                    }
                }
                if (totalOffset <= -0.9 * rowWidth) {
                    finalOffset = -rowWidth;
                    if (!pendingDeleteIds.value.includes(item.id)) {
                        pendingDeleteIds.value.push(item.id);
                        const deleteAction = props.actions.find(a => a.type === 'delete');
                        if (deleteAction) {
                            emit('action-click', { item, action: deleteAction });
                        }
                    }
                }
                else if (totalOffset <= -props.swipeThreshold) {
                    finalOffset = -props.actionWidth;
                }
                else {
                    finalOffset = 0;
                    globalSwipeState.clearOpenId();
                }
                Object.assign(swipeState, {
                    swiping: false,
                    finalOffset: finalOffset,
                    isSwiping: false
                });
                clickStartTime = null;
                clickStartX = null;
                emit('swipe-end', { item, event, offset: finalOffset });
                return;
            }
            if (swipeState.initialOffset < 0) {
                if (totalOffset > -props.swipeThreshold) {
                    finalOffset = 0;
                    globalSwipeState.clearOpenId();
                }
                else {
                    finalOffset = -props.actionWidth;
                }
            }
            else {
                if (totalOffset <= -props.swipeThreshold) {
                    finalOffset = -props.actionWidth;
                }
                else {
                    globalSwipeState.clearOpenId();
                }
            }
            Object.assign(swipeState, {
                swiping: false,
                finalOffset: finalOffset,
                isSwiping: false
            });
            clickStartTime = null;
            clickStartX = null;
            emit('swipe-end', { item, event, offset: finalOffset });
        }
        function cancelSwipe(item) {
            resetSwipeState(item);
            globalSwipeState.clearOpenId();
            emit('swipe-cancel', { item });
        }
        function getSwipeOffset(item) {
            const swipeState = getSwipeState(item);
            if (!swipeState)
                return 0;
            if (swipeState.swiping) {
                const diff = swipeState.currentX - swipeState.startX;
                return (swipeState.initialOffset || 0) + diff;
            }
            return swipeState.finalOffset || 0;
        }
        function getContentStyle(item) {
            if (pendingDeleteIds.value.includes(item.id) || leavingIds.value.includes(item.id)) {
                return {
                    transform: `translateX(-100%)`,
                    transition: 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
                };
            }
            const offset = getSwipeOffset(item);
            const swipeState = getSwipeState(item);
            return {
                transform: `translateX(${offset}px)`,
                transition: swipeState?.swiping ? 'none' : 'transform 0.8s cubic-bezier(0.4, 0, 0.2, 1)',
                borderRadius: offset < 0 ? '0 8px 8px 0' : '0'
            };
        }
        function getActionsStyle(item) {
            const swipeState = getSwipeState(item);
            return {
                transition: swipeState?.swiping ? 'none' : 'transform 0.8s cubic-bezier(0.4, 0, 0.2, 1)'
            };
        }
        function handleContentClick(item) {
            emit('content-click', { item });
        }
        function getVisibleActions(item) {
            if (!props.mailStyleSwipe)
                return props.actions;
            if (pendingDeleteIds.value.includes(item.id)) {
                return props.actions.filter(a => a.type === 'delete');
            }
            const offset = getSwipeOffset(item);
            let rowWidth = 1;
            const el = instance?.proxy?.$el;
            if (el && el.querySelector) {
                const row = el.querySelector(`[data-item-id="${item.id}"]`);
                if (row && row.offsetWidth) {
                    rowWidth = row.offsetWidth;
                }
            }
            if (offset < -0.6 * rowWidth) {
                const deleteAction = props.actions.find(a => a.type === 'delete');
                if (deleteAction) {
                    let grow = Math.min(1, Math.max(0, (-offset - 0.6 * rowWidth) / (0.25 * rowWidth)));
                    let widthPercent = 100 + grow * 100;
                    return [{ ...deleteAction, _growWidth: widthPercent }];
                }
            }
            return props.actions;
        }
        function getActionsWidth(item) {
            if (!props.mailStyleSwipe)
                return `${props.actionWidth}px`;
            if (leavingIds.value.includes(item.id)) {
                let rowWidth = 1;
                const el = instance?.proxy?.$el;
                if (el && el.querySelector) {
                    const row = el.querySelector(`[data-item-id="${item.id}"]`);
                    if (row && row.offsetWidth) {
                        rowWidth = row.offsetWidth;
                    }
                }
                return `${props.actionWidth + rowWidth}px`;
            }
            const offset = getSwipeOffset(item);
            let rowWidth = 1;
            const el = instance?.proxy?.$el;
            if (el && el.querySelector) {
                const row = el.querySelector(`[data-item-id="${item.id}"]`);
                if (row && row.offsetWidth) {
                    rowWidth = row.offsetWidth;
                }
            }
            if (offset < -0.6 * rowWidth) {
                let grow = Math.min(1, Math.max(0, (-offset - 0.6 * rowWidth) / (0.25 * rowWidth)));
                let width = props.actionWidth + grow * rowWidth;
                return `${width}px`;
            }
            return `${props.actionWidth}px`;
        }
        function removePendingDelete(id) {
            const idx = pendingDeleteIds.value.indexOf(id);
            if (idx !== -1)
                pendingDeleteIds.value.splice(idx, 1);
        }
        function beforeLeave(el) {
            const id = el.getAttribute('data-item-id');
            if (id && !leavingIds.value.includes(id)) {
                leavingIds.value.push(id);
            }
        }
        function afterLeave(el) {
            const id = el.getAttribute('data-item-id');
            if (id) {
                const idx = leavingIds.value.indexOf(id);
                if (idx !== -1)
                    leavingIds.value.splice(idx, 1);
            }
        }
        watch(() => props.items, (newItems) => {
            newItems.forEach(item => {
                if (!swipeStates.value.has(item.id)) {
                    swipeStates.value.set(item.id, {
                        startX: 0,
                        currentX: 0,
                        swiping: false,
                        initialOffset: 0,
                        finalOffset: 0,
                        isSwiping: false
                    });
                }
            });
            swipeStates.value.forEach((_state, id) => {
                if (!newItems.find(item => item.id === id)) {
                    swipeStates.value.delete(id);
                }
            });
        }, { immediate: true });
        onMounted(() => {
            if (props.items.length > 0) {
                const firstItem = props.items[0];
                const swipeState = getSwipeState(firstItem);
                if (swipeState && props.preview) {
                    setTimeout(() => {
                        Object.assign(swipeState, {
                            finalOffset: -props.actionWidth
                        });
                        setTimeout(() => {
                            Object.assign(swipeState, {
                                finalOffset: 0
                            });
                        }, 500);
                    }, 500);
                }
            }
        });
        __expose({ removePendingDelete, resetSwipeState });
        return (_ctx, _cache) => {
            const _component_v_btn = _resolveComponent("v-btn");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_TransitionGroup, {
                    name: "swipe-fade",
                    tag: "div",
                    onBeforeLeave: beforeLeave,
                    onAfterLeave: afterLeave
                }, {
                    default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (listItem) => {
                            return (_openBlock(), _createElementBlock("div", {
                                key: listItem.id,
                                class: "swipe-row",
                                "data-item-id": listItem.id,
                                onMousedown: ($event) => (startSwipe($event, listItem)),
                                onMousemove: ($event) => (moveSwipe($event, listItem)),
                                onMouseup: ($event) => (endSwipe($event, listItem)),
                                onMouseleave: ($event) => (cancelSwipe(listItem)),
                                onTouchstart: ($event) => (startSwipe($event, listItem)),
                                onTouchmove: ($event) => (moveSwipe($event, listItem)),
                                onTouchend: ($event) => (endSwipe($event, listItem)),
                                onTouchcancel: ($event) => (cancelSwipe(listItem))
                            }, [
                                _createElementVNode("div", {
                                    class: "swipe-actions-container",
                                    style: _normalizeStyle(_ctx.mailStyleSwipe ? { backgroundColor: _ctx.actions[0]?.backgroundColor || 'var(--background-color-alt)' } : {}),
                                    onMousedown: _cache[6] || (_cache[6] = _withModifiers(() => { }, ["stop"])),
                                    onTouchstart: _cache[7] || (_cache[7] = _withModifiers(() => { }, ["stop"]))
                                }, [
                                    _createElementVNode("div", {
                                        class: "swipe-actions swipe-actions-right",
                                        style: _normalizeStyle(Object.assign({}, getActionsStyle(listItem), { width: getActionsWidth(listItem) })),
                                        onMousedown: _cache[4] || (_cache[4] = _withModifiers(() => { }, ["stop"])),
                                        onTouchstart: _cache[5] || (_cache[5] = _withModifiers(() => { }, ["stop"]))
                                    }, [
                                        (getVisibleActions(listItem).length > 0)
                                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(getVisibleActions(listItem), (action) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                    key: action.type,
                                                    class: "action-container",
                                                    style: _normalizeStyle({
                                                        backgroundColor: action.backgroundColor || 'var(--background-color-alt)',
                                                        width: '100%'
                                                    })
                                                }, [
                                                    (action.image)
                                                        ? (_openBlock(), _createElementBlock("img", {
                                                            key: 0,
                                                            src: action.image,
                                                            class: "action-img",
                                                            onMousedown: _cache[0] || (_cache[0] = _withModifiers(() => { }, ["stop"])),
                                                            onTouchstart: _cache[1] || (_cache[1] = _withModifiers(() => { }, ["stop"])),
                                                            onClick: _withModifiers(($event) => (emit('action-click', { item: listItem, action })), ["stop", "prevent"])
                                                        }, null, 40, _hoisted_3))
                                                        : (_openBlock(), _createBlock(_component_v_btn, {
                                                            key: 1,
                                                            icon: action.icon,
                                                            variant: "text",
                                                            size: "large",
                                                            color: action.color || 'grey',
                                                            class: "action-btn",
                                                            onMousedown: _cache[2] || (_cache[2] = _withModifiers(() => { }, ["stop"])),
                                                            onTouchstart: _cache[3] || (_cache[3] = _withModifiers(() => { }, ["stop"])),
                                                            onClick: _withModifiers(($event) => (emit('action-click', { item: listItem, action })), ["stop", "prevent"])
                                                        }, null, 8, ["icon", "color", "onClick"]))
                                                ], 4));
                                            }), 128))
                                            : _renderSlot(_ctx.$slots, "actions", {
                                                key: 1,
                                                item: listItem
                                            })
                                    ], 36)
                                ], 36),
                                _createElementVNode("div", {
                                    class: "swipe-content",
                                    style: _normalizeStyle(getContentStyle(listItem)),
                                    onClick: _withModifiers(($event) => (handleContentClick(listItem)), ["stop"])
                                }, [
                                    _renderSlot(_ctx.$slots, "default", { item: listItem })
                                ], 12, _hoisted_4)
                            ], 40, _hoisted_2));
                        }), 128))
                    ]),
                    _: 3
                })
            ]));
        };
    }
});
